module.exports = __webpack_public_path__ + "img/icon-0.924cfae7.png";